import React from 'react';
import { Container, Paper } from 'library';

import './AwardsBlock.scss';

const AwardsBlock = ({ awards = [] }) => {
  if (awards.length === 0) {
    return null;
  }

  return (
    <Paper className="AwardsBlock" theme="dark">
      <div className="AwardsBlockWrapper">
        <h3 className="AwardsBlockHeader">Awards & Nominations</h3>
        <Container row>
          {awards.map((award) => {
            return (
              <Container grid={6} respondAt="md" key={award.awardTitle}>
                <div className="AwardsBlockAward">
                  <h3>{award.awardTitle}</h3>
                  <p>{award.awardSubtitle}</p>
                </div>
              </Container>
            );
          })}
        </Container>
      </div>
    </Paper>
  );
};

export default AwardsBlock;
